"use client";import createIcon from'./util/createIcon';export default createIcon('M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z','ArrowDownBold');